const convertToCm = (value = 0, uom = 'cm') => {
    if (!value) return 0;
    const unit = (uom || 'cm').trim().toLowerCase();

    switch (unit) {
        case 'inches':
        case 'inch':
        case 'in':
            return value * 2.54;
        case 'ft':
        case 'feet':
        case 'foot':
            return value * 30.48;
        case 'mm':
            return value * 0.1;
        case 'm':
        case 'meter':
        case 'metre':
        case 'meters':
        case 'metres':
            return value * 100;
        default:
            return value;
    }
};

export const ThumbnailSvg = ({ fields, dmode }) => {

    const sortedFields = ((fields || []).sort(
        (a, b) => (a.fieldIndex ?? 0) - (b.fieldIndex ?? 0)
    ));

    const padding = 3; // left & right padding

    // Convert all dimensions to cm first
    const normalizedFields = sortedFields.map((f) => ({
        ...f,
        widthCm: convertToCm(f.width ?? 0, f.uom),
        heightCm: convertToCm(f.height ?? 0, f.uom),
    }));

    // Calculate total width & max height in cm
    const totalWidthCm = normalizedFields.reduce((sum, f) => sum + f.widthCm, 0);
    const maxHeightCm = Math.max(...normalizedFields.map(f => f.heightCm || 20), 20);

    // Scale so fields fit inside 80x25 viewport
    const widthScale = (80 - padding * 2) / totalWidthCm;
    const heightScale = (25 - padding * 2) / maxHeightCm;
    const scale = Math.min(widthScale, heightScale);

    let xOffset = padding;

    return (
        <svg
            viewBox={`0 0 80 25`}
            height={25}
            xmlns="http://www.w3.org/2000/svg"
            style={{ 
                background:  'transparent', 
                border: 'transparent' 
            }}
        >
            {normalizedFields.map((field) => {
                const fieldWidth = field.widthCm * scale;
                const fieldHeight = field.heightCm * scale;
                const yOffset = 25 - fieldHeight - padding; // bottom align

                const rect = (
                    <rect
                        key={field.id}
                        x={xOffset}
                        y={yOffset}
                        width={fieldWidth}
                        height={fieldHeight}
                        fill="transparent"
                        stroke={dmode ? 'white' : "#5128a0"}
                        strokeWidth={1}
                    />
                );

                xOffset += fieldWidth;
                return rect;
            })}
        </svg>
    );
};
